import { BaseRouteService } from 'core/services';

class ProductTypeTagRouteService extends BaseRouteService {
    constructor() {
        super('product-type-tags');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,defaultItemTypeId}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }
    
    create(resource) {
        return super.create(this.base, resource);
    }
}

export default ProductTypeTagRouteService;
